// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@0.7.5_webpack@5.99.9_@swc+core@1.12.4_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-details-view-image-image] {
    width: 100%;
    height: 100%;
    margin-block-start: 10px;
    display: flex;
    justify-content: center;
}

[data-details-view-image-image] > video,
[data-details-view-image-image] > iframe {
    width: 100%;
    height: 100%;
}

[data-details-view-image-image] > img {
    width: auto;
    height: 100%;
    max-width: 100%;
    object-fit: contain;
}

.common-details-view-image-info {
    margin-bottom: 10px;
    width: 65%;
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-top: 5px;
}

.common-details-view-image-info > * {
    width: 100%;
}

.common-details-view-image-info h3[data-details-view-image-info-title] {
    margin-block: 0;
}

.common-details-view-image-info [data-details-view-image-info-title-event] {
    display: none;
}

.title-with-link-container {
    display: flex;
    align-items: center;
}

.title-with-link-container .secondary-text,
.title-with-link-container .secondary-text span {
    color: var(--primary);
}

.title-with-link-container .secondary-text span:hover {
    cursor: pointer;
}

.title-with-link-container .title {
    margin: 16px 0;
    bottom: 2px;
    margin-bottom: 0;
    margin-top: 3px;
    font-weight: bold;
}

.title-with-link-container .secondary-text {
    top: 0;
    margin-inline-start: 10px;
    transition: opacity 0.8s ease;
    display: flex;
    align-items: center;
}

.title-with-link-container .secondary-text:hover {
    transform: scale(1.1);
    transition: transform 0.2s ease;
}

.separator {
    border-left: 1px solid var(--outline-variant);
    margin: 0 5px;
}

.inline-paragraph {
    display: block !important;
}

.inline-paragraph span,
.inline-paragraph a {
    display: inline;
}

.auth-buttons-block {
    display: flex;
    flex-wrap: nowrap;
    padding: 5px;
    justify-content: center;
    gap: 10px;
}

.custom-outlined-button {
    --md-outlined-button-label-text-color: var(--on-surface);
    --md-outlined-button-icon-color: var(--on-surface);
}

.common-amount-elements {
    display: none;
    background-color: var(--primary);
    color: var(--on-primary);
    border-radius: var(--radius-circle);
    height: 15px;
    width: 15px;
    justify-content: center;
    align-items: center;
    align-self: flex-start;
}

.common-exclusive-watermark-img {
    position: absolute;
    top: 0;
    left: 15%;
    width: 70% !important;
    height: 100%;
    z-index: 1;
    pointer-events: none;
    user-select: none;
    touch-action: none;
    object-fit: contain;
    object-position: center;
    mix-blend-mode: soft-light;
}

.selected-text {
    display: inline;
}

.selected-option {
    display: flex;
    align-items: center;
    cursor: pointer;
    background-color: transparent;
    border: none;
    padding: 3px;
    transition: background-color 0.2s;
    gap: 5px;
}

.selected-option:hover {
    background-color: var(--primary-container); /* Change the background color on hover */
    color: var(--on-primary-container);
    border-radius: var(--radius-extra-small);
}

.option-active {
    background-color: var(--primary-container); /* Change the background color on hover */
    color: var(--on-primary-container);
    border-radius: 5px;
}

.hover-effect {
    position: relative;
    display: inline;
    z-index: 1;
}

.even-background {
    background-color: var(--surface-variant);
}

.tab-select {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    align-items: center;
    position: relative;
}

@media (width < 740px) {
    .tab-select {
        flex-wrap: wrap;
    }
}
`, "",{"version":3,"sources":["webpack://./../../assets/css/custom-common.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,MAAM;IACN,yBAAyB;IACzB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA;IACI,6CAA6C;IAC7C,aAAa;AACjB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,wDAAwD;IACxD,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,wBAAwB;IACxB,mCAAmC;IACnC,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,qBAAqB;IACrB,YAAY;IACZ,UAAU;IACV,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,YAAY;IACZ,YAAY;IACZ,iCAAiC;IACjC,QAAQ;AACZ;;AAEA;IACI,0CAA0C,EAAE,yCAAyC;IACrF,kCAAkC;IAClC,wCAAwC;AAC5C;;AAEA;IACI,0CAA0C,EAAE,yCAAyC;IACrF,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,QAAQ;IACR,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ","sourcesContent":["[data-details-view-image-image] {\n    width: 100%;\n    height: 100%;\n    margin-block-start: 10px;\n    display: flex;\n    justify-content: center;\n}\n\n[data-details-view-image-image] > video,\n[data-details-view-image-image] > iframe {\n    width: 100%;\n    height: 100%;\n}\n\n[data-details-view-image-image] > img {\n    width: auto;\n    height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n}\n\n.common-details-view-image-info {\n    margin-bottom: 10px;\n    width: 65%;\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    margin-top: 5px;\n}\n\n.common-details-view-image-info > * {\n    width: 100%;\n}\n\n.common-details-view-image-info h3[data-details-view-image-info-title] {\n    margin-block: 0;\n}\n\n.common-details-view-image-info [data-details-view-image-info-title-event] {\n    display: none;\n}\n\n.title-with-link-container {\n    display: flex;\n    align-items: center;\n}\n\n.title-with-link-container .secondary-text,\n.title-with-link-container .secondary-text span {\n    color: var(--primary);\n}\n\n.title-with-link-container .secondary-text span:hover {\n    cursor: pointer;\n}\n\n.title-with-link-container .title {\n    margin: 16px 0;\n    bottom: 2px;\n    margin-bottom: 0;\n    margin-top: 3px;\n    font-weight: bold;\n}\n\n.title-with-link-container .secondary-text {\n    top: 0;\n    margin-inline-start: 10px;\n    transition: opacity 0.8s ease;\n    display: flex;\n    align-items: center;\n}\n\n.title-with-link-container .secondary-text:hover {\n    transform: scale(1.1);\n    transition: transform 0.2s ease;\n}\n\n.separator {\n    border-left: 1px solid var(--outline-variant);\n    margin: 0 5px;\n}\n\n.inline-paragraph {\n    display: block !important;\n}\n\n.inline-paragraph span,\n.inline-paragraph a {\n    display: inline;\n}\n\n.auth-buttons-block {\n    display: flex;\n    flex-wrap: nowrap;\n    padding: 5px;\n    justify-content: center;\n    gap: 10px;\n}\n\n.custom-outlined-button {\n    --md-outlined-button-label-text-color: var(--on-surface);\n    --md-outlined-button-icon-color: var(--on-surface);\n}\n\n.common-amount-elements {\n    display: none;\n    background-color: var(--primary);\n    color: var(--on-primary);\n    border-radius: var(--radius-circle);\n    height: 15px;\n    width: 15px;\n    justify-content: center;\n    align-items: center;\n    align-self: flex-start;\n}\n\n.common-exclusive-watermark-img {\n    position: absolute;\n    top: 0;\n    left: 15%;\n    width: 70% !important;\n    height: 100%;\n    z-index: 1;\n    pointer-events: none;\n    user-select: none;\n    touch-action: none;\n    object-fit: contain;\n    object-position: center;\n    mix-blend-mode: soft-light;\n}\n\n.selected-text {\n    display: inline;\n}\n\n.selected-option {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    background-color: transparent;\n    border: none;\n    padding: 3px;\n    transition: background-color 0.2s;\n    gap: 5px;\n}\n\n.selected-option:hover {\n    background-color: var(--primary-container); /* Change the background color on hover */\n    color: var(--on-primary-container);\n    border-radius: var(--radius-extra-small);\n}\n\n.option-active {\n    background-color: var(--primary-container); /* Change the background color on hover */\n    color: var(--on-primary-container);\n    border-radius: 5px;\n}\n\n.hover-effect {\n    position: relative;\n    display: inline;\n    z-index: 1;\n}\n\n.even-background {\n    background-color: var(--surface-variant);\n}\n\n.tab-select {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n    align-items: center;\n    position: relative;\n}\n\n@media (width < 740px) {\n    .tab-select {\n        flex-wrap: wrap;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
